export const membershipSubordinateCacheKeys = {
  paginated_subordinates: pathParams =>
    ['paginated_subordinates', pathParams] as const,
  subordinates: pathParams => ['subordinates', pathParams] as const
}
